import * as React from "react";
import { cn } from "../../lib/utils";
import { Button } from "./button";

interface AlertDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
}

export const AlertDialog = ({ open, onOpenChange, children }: AlertDialogProps) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div 
        className="fixed inset-0 bg-black/50" 
        onClick={() => onOpenChange(false)}
      />
      <div className="relative bg-white rounded-lg shadow-lg max-w-md w-full mx-4 p-6 z-50">
        {children}
      </div>
    </div>
  );
};

interface AlertDialogContentProps {
  children: React.ReactNode;
  className?: string;
}

export const AlertDialogContent = ({ children, className }: AlertDialogContentProps) => {
  return <div className={cn("space-y-4", className)}>{children}</div>;
};

interface AlertDialogHeaderProps {
  children: React.ReactNode;
}

export const AlertDialogHeader = ({ children }: AlertDialogHeaderProps) => {
  return <div className="space-y-2">{children}</div>;
};

interface AlertDialogTitleProps {
  children: React.ReactNode;
}

export const AlertDialogTitle = ({ children }: AlertDialogTitleProps) => {
  return <h2 className="text-lg font-semibold text-gray-900">{children}</h2>;
};

interface AlertDialogDescriptionProps {
  children: React.ReactNode;
}

export const AlertDialogDescription = ({ children }: AlertDialogDescriptionProps) => {
  return <p className="text-sm text-gray-500">{children}</p>;
};

interface AlertDialogFooterProps {
  children: React.ReactNode;
}

export const AlertDialogFooter = ({ children }: AlertDialogFooterProps) => {
  return <div className="flex justify-end gap-2">{children}</div>;
};

interface AlertDialogActionProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export const AlertDialogAction = ({ children, ...props }: AlertDialogActionProps) => {
  return <Button {...props}>{children}</Button>;
};

interface AlertDialogCancelProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export const AlertDialogCancel = ({ children, onClick, ...props }: AlertDialogCancelProps) => {
  return <Button variant="outline" onClick={onClick} {...props}>{children}</Button>;
};
